import React, { useEffect, useState } from 'react';
import { InputNumber, Form, Input, Select, Button } from 'antd';
import { GET, queryFilterByItem, errorCatch, JSXMap, useAuth, deleteArrayInArray, triggerInArray, updateArrayInArray } from 'fennec-ui'
import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import ObjectContextDescription from '../../../fedance-ui/ContextDescription';
import Icofont from 'react-icofont';
var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone') // dependent on utc plugin
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.locale('ru');
var _ = require('lodash');

function CollectionPanel(props) {
    const { data, renderItem, title, height, style, className } = props;
    return (
        <div className={`collection-panel ${(className) ? className : ""}`} style={style}>
            {(_.isFunction(title)) ? title() : title}
            <div className={`collection-panel-content ${(height) ? "scrollable" : ""}`} style={(height) ? { maxHeight: height } : {}}>
                {JSXMap(data, renderItem)}
            </div>
        </div>
    )
}

{/* <Promocodes collection={promocodes} value={command} onChange={onChange} color={color} /> */ }

const Promocodes = (props) => {
    const { collection: allPromocodes, color, value, onChange } = props;
    const auth = useAuth();
    // const t = useTranslateContext();
    const [editing, setEditing] = useState(false);

    // const [allPromocodes, setAllPromocodes] = useState([]);
    const [selectedAllPromocodes, setSelectedAllPromocodes] = useState([]);
    const [team, setTeam] = useState([]);
    const [selectedTeam, setSelectedTeam] = useState([]);

    useEffect(() => {
        if (value) {
            setTeam(value || []);
        }
    }, [value]);

    // console.log(allPromocodes, selectedAllPromocodes, team, selectedTeam);

    const append = React.useCallback(() => {
        
        // setSelectedAllPromocodes((o) => deleteArrayInArray(o || [], selectedTeam));
        onChange(updateArrayInArray(team || [], selectedAllPromocodes));
        // POST(auth, `/api/adddancercommand/command/${command.ID}`, selectedAllPromocodes,
        //     ({ data }) => {
        //         setSelectedAllPromocodes((o) => deleteArrayInArray(o || [], data.map(m => m.eventUser)));
        //         onChange({
        //             ...command,
        //             dancerCommandCommand: updateArrayInArray(command.dancerCommandCommand || [], data)
        //         });
        //     }, errorCatch);
    }, [selectedAllPromocodes, team, selectedTeam]);
    const remove = React.useCallback(() => {
        // setSelectedTeam((o) => deleteArrayInArray(o || [], selectedTeam));
        onChange(deleteArrayInArray(team || [], selectedTeam));
        // POST(auth, `/api/dropdancercommand`, selectedTeam,
        //     ({ data }) => {
        //         setSelectedTeam((o) => deleteArrayInArray(o || [], selectedTeam));
        //         onChange({
        //             ...command,
        //             dancerCommandCommand: deleteArrayInArray(command.dancerCommandCommand || [], selectedTeam)
        //         });
        //     }, errorCatch);
    }, [team, selectedTeam]);
    return (
        <div>
            {<div style={{
                paddingLeft: "10px",
                marginLeft: "2px",
                borderLeft: (color) ? `2px solid ${color}` : `2px solid rgba(190, 190, 190, 0.2)`
            }}>
                <div style={{ paddingLeft: "8px" }}>
                    {/* Услуга которую добавляем */}
                </div>
                {((!team || team.length == 0) && (!editing)) && <div style={{ padding: "10px 0px" }}>
                    <Button
                        onClick={() => setEditing(!editing)}
                        className="onhover fade-in"
                        type="text"
                        style={{
                            width: "100%",
                            height: "60px",
                            borderRadius: "4px",
                            border: "1px dotted lightgray"
                        }}>
                        <div>
                            <div style={{ fontSize: "18px" }}><Icofont icon="ui-add" style={{ fontSize: "12px" }} /> {"Добавить промокод"}</div>
                            <div style={{
                                fontSize: "12px",
                                fontStyle: "italic",
                                color: "rgba(0, 0, 0, 0.65)"
                            }}>{"Пока нет промокодов"}</div>
                        </div>
                    </Button>
                </div>}

                {((team && team.length > 0) || (editing)) && <div>
                    <div style={{ padding: "10px 0px 0px 0px" }}>
                        <div className='bg bg-grey button pointer' onClick={() => setEditing(!editing)}>
                            {(editing) ? "Завершить редактирование" : "Редактировать промокоды"}
                        </div>
                    </div>
                    <div style={{
                        display: "flex",
                        justifyContent: "space-between",
                        gap: 5,
                        padding: "10px 0px"
                    }}>
                        {(editing === true) && <div style={{ flex: 1 }}>
                            <CollectionPanel
                                data={deleteArrayInArray(allPromocodes, team)}
                                height="400px"
                                // title={({ count }) => <DancerCountByGender title={"Все промокоды") male={count.male} female={count.female} style={{ padding: "3px 0px" }} />}
                                title={() => "Все промокоды"}
                                renderItem={(e, idx) => {
                                    let desc = "";
                                    if (e?.organizatorFederatsiya) {
                                        desc = "Федерация"
                                    } else if (e?.organizatorRegionalnoeOtdelenie) {
                                        desc = "" + e?.organizatorRegionalnoeOtdelenie?.nazvanie
                                    } else if (e?.organizatorShkola) {
                                        desc = "" + e?.organizatorShkola?.nazvanieShkoliTantsev
                                    } else if (e?.organizatorMeropriyatiya) {
                                        desc = "" + e?.organizatorMeropriyatiya?.nazvanie
                                    }

                                    if (e?.meropriyatie) {
                                        desc += ", " + `${e?.meropriyatie?.nazvanieMeropriyatiya} - ${dayjs(e?.meropriyatie?.nachaloSorevnovaniya).format("DD.MM.YYYY")} ${(e?.meropriyatie?.mestoProvedeniya) ? "(" + e?.meropriyatie?.mestoProvedeniya?.name + ")" : ""}`
                                    }
                                    return (
                                        <div
                                            key={idx}
                                            onClick={() => setSelectedAllPromocodes((o) => triggerInArray(o, e))}
                                            style={{ textAlign: "left", margin: "1px", padding: "2px 5px" }}
                                            className={`bg ${(selectedAllPromocodes?.find(x => x.ID === e.ID) !== undefined) ? "bg-blue" : "bg-grey"} pointer`}
                                        >
                                            <div style={{ fontWeight: "bold" }}>
                                                <span>{e.promokod}</span> <span style={{ fontWeight: "lighter", color: "rgba(0,0,0,.65)" }}>{e.opisanie}</span>
                                            </div>
                                            {desc && <div style={{ fontSize: "12px", fontWeight: "lighter" }}>{desc}</div>}
                                        </div>
                                    )
                                }}
                            />
                        </div>}
                        {(editing === true) && <div style={{ flex: 0, alignSelf: "center", padding: "0px 10px", display: "flex", flexDirection: "column", justifyContent: "center", gap: 5 }}>
                            <Button onClick={append}><Icofont icon="rounded-right" /></Button>
                            <Button onClick={remove}><Icofont icon="rounded-left" /></Button>
                        </div>}
                        <div style={{ flex: 1 }}>
                            <CollectionPanel
                                data={team}
                                height="400px"
                                // title={({ count }) => <DancerCountByGender title={`Выбранные промокоды`} male={count.male} female={count.female} style={{ padding: "3px 0px" }} />}
                                title={() => "Выбранные промокоды"}
                                renderItem={(e, idx) => {
                                    let desc = "";
                                    if (e?.organizatorFederatsiya) {
                                        desc = "Федерация"
                                    } else if (e?.organizatorRegionalnoeOtdelenie) {
                                        desc = "" + e?.organizatorRegionalnoeOtdelenie?.nazvanie
                                    } else if (e?.organizatorShkola) {
                                        desc = "" + e?.organizatorShkola?.nazvanieShkoliTantsev
                                    } else if (e?.organizatorMeropriyatiya) {
                                        desc = "" + e?.organizatorMeropriyatiya?.nazvanie
                                    }

                                    if (e?.meropriyatie) {
                                        desc += ", " + `${e?.meropriyatie?.nazvanieMeropriyatiya} - ${dayjs(e?.meropriyatie?.nachaloSorevnovaniya).format("DD.MM.YYYY")} ${(e?.meropriyatie?.mestoProvedeniya) ? "(" + e?.meropriyatie?.mestoProvedeniya?.name + ")" : ""}`
                                    }
                                    return (
                                        <div
                                            key={idx}
                                            onClick={() => {
                                                if (editing) {
                                                    setSelectedTeam((o) => triggerInArray(o, e));
                                                }
                                            }}
                                            style={{ textAlign: "left", margin: "1px", padding: "2px 5px" }}
                                            className={`bg ${((editing) ? selectedTeam?.find(x => x.ID === e.ID) !== undefined : false) ? "bg-blue" : "bg-grey"} pointer`}
                                        >
                                            <div style={{ fontWeight: "bold" }}>
                                                <span>{e.promokod}</span> <span style={{ fontWeight: "lighter", color: "rgba(0,0,0,.65)" }}>{e.opisanie}</span>
                                            </div>
                                            {desc && <div style={{ fontSize: "12px", fontWeight: "lighter" }}>{desc}</div>}
                                        </div>
                                    )
                                }}
                            // renderItem={(e, idx) => (
                            //     <div
                            //         key={idx}
                            //         onClick={() => {
                            //             if (editing) {
                            //                 setSelectedTeam((o) => triggerInArray(o, e));
                            //             }
                            //         }}
                            //         // gender={(item) => item.eventUser.user.genderID}
                            //         // item={e}
                            //         // key={e.ID} name={`${e.eventUser.user.lastname} ${e.eventUser.user.firstname}`}
                            //         // className={(editing) ? "pointer" : ""}
                            //         selected={(editing) ? selectedTeam?.find(x => x.ID === e.ID) !== undefined : false}
                            //     />
                            // )}
                            />
                        </div>
                    </div>
                </div>}

            </div>}
        </div >
    )
}

export default function AddYacheikaVPromokodi(props) {
    const { auth, object, form, sourceKey, queryFilterContext, soruceID, parentObject } = props;
    const [promokodi, setPromokodi] = useState([])
    useEffect(() => {
        form.resetFields();

        // /api/promokodi/list/meropriyatie/${event.ID}?detail=model
        // /api/promokodi/list/reg?detail=model
        // /api/promokodi/list/fed?detail=model
        // /api/promokodi/list/org?detail=model
        // /api/promokodi/list/school?detail=model

        let postfix = "";
        if (sourceKey === "admin") {
            postfix = `/${soruceID}`
        }
        GET(auth, "/api/promokodi/list/" + sourceKey + postfix + "?detail=model&w-notActive=false&" + (soruceID ? `w-eqornu-meropriyatie.ID=${soruceID}&` : "") + ((queryFilterContext) ? queryFilterByItem(queryFilterContext) : ""),
            ({ data }) => {
                setPromokodi(data)
            },
            (err) => errorCatch(err));

    }, []);

    return (
        <>
            <ObjectContextDescription object={object} /*title={"Номенклатура"}*/ />
            <Form
                form={form}
                onFinish={props.submit}
                labelAlign={"left"}
                layout={"vertical"}
                initialValues={{
                    ...object
                }}
            >
                <Form.Item label="Процент"
                    name="protsent"
                    rules={[{ required: false, message: 'Пожалуйста, укажите процент!' }]}
                >
                    <InputNumber />
                </Form.Item>
                <Form.Item label="Сумма"
                    name="summa"
                    rules={[{ required: false, message: 'Пожалуйста, укажите сумму!' }]}
                >
                    <InputNumber />
                </Form.Item>
                <Form.Item label="Промокоды"
                    name="promokodiList"
                    rules={[{ required: false, message: 'Пожалуйста, выберите промокоды!' }]}
                >
                    <Promocodes collection={promokodi} />
                </Form.Item>

            </Form>
        </>
    );
}
